module.exports = require('./helpers/bundle-url').getBundleURL('i3X7Z') + "logo-dark.ba5147f0.svg";